<script lang="js">
import { defineComponent, ref } from 'vue-demi';
import * as layerNames from '../../services/layerName';
import Layer from '../Layer.vue';
export default defineComponent({
  components: {
    Layer
  },
  props: {
    rules: {
      type: String,
      required: true,
    },
    title:{
      type: String,
      default:'活动规则'
    },
    seriesName:{
      type: String,
      default:''
    }

  },
  setup () {
    const visible = ref(true);
    const close = () => {
      visible.value = false;
    };
    return {
      close,
      visible,
      layerName: layerNames.RED_PACKET_RULE_LAYER
    };
  },
});
</script>
<template>
  <!-- 弹窗红包 -->
  <Layer :layerName="layerName" :visible="visible" maskDirection="Middle">
    <div class="dlrLayer-middle dlrRedPackNewRule">
      <div class="dlrRedPackNewRule-bg">
        <span class="dlrRedPackNewRule-close" @click="close"></span>
        <div class="dlrRedPackNewRule-title">{{title}}</div>
        <div class="dlrRedPackNewRule-cont">
          <div class="dlrRedPackNew-word">
            <div class="dlrRedPackNew-word_cont">
                <slot></slot>
                <div  v-html="rules"></div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>

 <style lang="scss">
//@import './scss/Rule.scss';
</style>
